<template>
    <div class="container-fluid footer">
        <div class="footer-block row">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-lg-3">
                        <a :href="brandWebsite" target="_blank">
                            <v-lazy-image :src="'/img/brand/' + brand"
                                          alt="logo"
                                          class="logo"
                                          :placeholder="'/img/brand/' + brand" />
                        </a>
                        <div class="social-icons" role="list">
                            <a v-for="(media, i) in social" :key="i" :href="media.url" class="icon-item" target="_blank">
                                <i v-bind:class="['social fab ' +media.icon]" :title="media.label"></i>
                                <span class="sr-only">{{media.label}}</span>
                            </a>                    
                        </div>
                    </div>
                    <div v-for="(item, i) in data" :key="i" class="col-sm-12 col-md-4 col-lg-3">
                        <span class="h5">{{item.title}}</span>
                        <div class="column-content">
                            <ul class="">
                                <li v-for="(link, index) in item.menubar" :key="index">
                                    <a :href="link.link" :target="link.target">{{ link.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-3 addr-box">
                        <span class="h5">{{dealerLocation?.name}}</span>
                        <div class="column-content">
                            <p>{{dealerLocation?.address?.addressLine1}}</p>
                            <p v-if="this.dealerLocation.address?.addressLine2">{{this.dealerLocation?.address?.addressLine2}}</p>
                            <p v-if="dealerLocation?.address?.city || dealerLocation?.address?.state || dealerLocation?.address?.postalCode">{{dealerLocation.address.city}}, {{dealerLocation.address.state}} {{dealerLocation.address.postalCode}}</p>
                            <p v-if="dealerLocation?.address?.country">{{dealerLocation.address.country}}</p>
                            <p v-if="dealerLocation?.salesPhoneNo === dealerLocation?.servicePhoneNo">
                                <strong>{{phoneNo}}:</strong> {{dealerLocation?.salesPhoneNo}}
                            </p>
                            <template v-if="dealerLocation?.salesPhoneNo !== dealerLocation?.servicePhoneNo">
                                <p><strong>{{salesNo}}:</strong> {{dealerLocation?.salesPhoneNo}}</p>
                                <p><strong>{{serviceNo}}:</strong> {{dealerLocation?.servicePhoneNo}}</p>
                            </template>                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-copy row pt-5">
            <div class="col-sm-12 col-md-6">
                <ul class="">
                    <li class="text-left mx-2" v-for="(item, index) in this.termCondition" :key="index">
                        <a :href="item.url" :target="item.target">{{ item.label }}</a>
                    </li>
                    <li class="text-left mx-2">
                        <a href="javascript:void(0);" @click="showCookieSettings()">Cookie Settings</a>
                    </li>
                </ul>
            </div>
            <div class="col-sm-12 col-md-6"><p>&copy; {{copyright}}</p></div>            
        </div>        
    </div>
</template>
<script>
    import VLazyImage from "v-lazy-image";
    import getBrandDetails from "../../constants/brand.config";
    import { businessHours, phoneNo, salesNo, serviceNo } from '../../constants/labels.config';
    import "bootstrap/dist/css/bootstrap.min.css";

    export default {
        name: "SiteFooter",
        props:['brand', 'data', 'social', 'copyright', 'termCondition'],
        data(){
            return {      
                dealerLocation:window.DEALER_LOCATION,   
                businessHours,
                phoneNo, 
                salesNo, 
                serviceNo,
                brandWebsite: getBrandDetails(sessionStorage.getItem("brand"), "brandUrl"),
            }
        },
        methods:{
            showCookieSettings: function(){
                 let showSettingsEvent = new Event('show_cookie_settings');
                document.dispatchEvent(showSettingsEvent);
            }
        },
        components: {
            VLazyImage,
        }
    };
</script>
